import { call, put } from 'redux-saga/effects'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { onOpenNotification } from 'redux/notification/reducer'
import {
	deleteUserAvatarFailure,
	deleteUserAvatarSuccess,
	getUserSuccess,
} from 'redux/user/reducer'
import { PayloadAction } from '@reduxjs/toolkit'
import { IUser } from './types'

export function* deleteUserAvatarSaga({ payload }: PayloadAction<{ isTeam: boolean }>) {
	try {
		const {
			data,
			message,
		}: {
			data: { user: IUser }
			message: string
		} = yield call(apiMiddleware, {
			url: payload.isTeam
				? app_config.services.deleteTeamLogo
				: app_config.services.deleteUserAvatar,
			method: 'POST',
		})

		yield put(getUserSuccess(data.user))
		yield put(deleteUserAvatarSuccess())

		yield put(
			onOpenNotification({
				message,
				notificationType: 'success',
			})
		)
	} catch (e) {
		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)

		yield put(deleteUserAvatarFailure())
	}
}
